import { createContext, useContext } from "react";

import { AccountScreenHelper } from "./AccountScreenHelper.ts";

export const AccountScreenContext = createContext({} as AccountScreenHelper);

export const useAccountScreenContext = () => useContext(AccountScreenContext);
